import { isDefined } from '../typeUtils/index.js';
/**
 * Returns true when any segment of the path is exactly `..`, treating both `/`
 * and `\` as separators. Checking segments rather than substrings catches
 * traversal in trailing position (`packets/..`) while leaving dots inside a
 * name alone (`packet..pdf`, `..packets/packet.pdf`).
 */
export function hasDirectoryTraversal(filePath) {
    return isDefined(filePath) && filePath.split(/[/\\]/).includes('..');
}
/**
 * Detects path traversal in a path or single path segment.
 *
 * Splits on both POSIX (`/`) and Windows (`\`) separators and returns true if
 * any resulting segment is `.` (current dir) or `..` (parent dir).
 *
 * Use this to reject user-controlled values before interpolating them into a
 * filesystem path or a request URL. `encodeURIComponent` does not escape `.`,
 * so a `..` segment survives URL interpolation and is then collapsed by
 * downstream URL/path normalization — letting a crafted value climb out of its
 * intended location.
 */
export function hasFilePathTraversalDots(filePath) {
    return (isDefined(filePath) &&
        filePath.split(/[/\\]/).some((segment) => segment === '.' || segment === '..'));
}
//# sourceMappingURL=filePaths.js.map